            
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">
      <b-form  inline style="margin-bottom:15px" novalidate >  
        <b-row style="width:100%">
          <b-col sm="12" style="padding:0">
            <b-row  class="row-inputs">              
              <b-col :md="6" :lg="6" style="padding:0 !important" v-show="dataIndex[namePath]!==false && dataIndex[namePath]!==10000">
                <div style="font-weight:500">{{name}}</div>          
              </b-col> 
              <sw-searchs
                v-if="dataIndex[namePath]===false || dataIndex[namePath]===10000"
                :md="6"
                :lg="6"
                label='Seleccionar afiliado'
                list='datos_afiliado'
                @input="searchsData()"
                filterCampos="documento"
                :filter="[{campo: 'id_list_estado', value: 1},{campo: 'servicios', value: 0}]"
              >
              </sw-searchs> 
              <b-col :md="6" :lg="6" style="padding:0 !important" v-show="dataForm[namePath].datos_afiliado.id>0">
                <b-row>
                  <b-col>
                    {{servicios}}
                  </b-col>
                  <b-col :md="3" class="text-right pl-0">
                    $ {{precio}}
                  </b-col>
                </b-row>              
              </b-col>  
              <b-col :md="6" :lg="6" style="padding:0 !important" v-show="dataIndex[namePath]!==false && dataIndex[namePath]!==10000 && dataForm[namePath].datos_afiliado.id===null">
                <div style="text-align: right;">El afiliado se encuentra Inactivo</div>          
              </b-col>          
            </b-row>
          </b-col>
            <sw-inputs
              v-if="dataForm[namePath].datos_afiliado.id>0"
              :md="6"
              :lg="6"
              inputTabla="datos_afiliado"
              inputCampo="email">
            </sw-inputs>
            <sw-inputs
              v-if="dataForm[namePath].datos_afiliado.id>0"
              :md="6"
              :lg="6"
              inputTabla="datos_afiliado"
              inputCampo="direccion">
            </sw-inputs>
            <sw-inputs
              v-if="dataForm[namePath].datos_afiliado.id>0"
              :md="6"
              :lg="6"
              inputTabla="datos_afiliado"
              inputCampo="ciudad">
            </sw-inputs>
            <sw-inputs
              v-if="dataForm[namePath].datos_afiliado.id>0"
              :md="6"
              :lg="6"
              inputTabla="datos_afiliado"
              inputCampo="telefonos">
            </sw-inputs>            
            <sw-inputs
              :md="12"
              :lg="12"
              inputTabla="notas_pendientes"
              inputCampo="nota">
            </sw-inputs>
        </b-row>  
      </b-form>    
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
            <sw-saveform
              v-if="dataIndex[namePath]===false || dataIndex[namePath]===10000"
              :index="dataIndex[namePath]"
              nameBtn="Nota"
              :invalid="invalid || searchSw.value===''"
              @save="save"
              >
            </sw-saveform>
            <sw-saveform
              v-else
              :index="dataIndex[namePath]"
              nameBtn="Nota"
              @save="save"
              >
            </sw-saveform>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState, mapActions } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import SwSearchs from '@/components/forms/searchs.vue'
export default 
{
  name: 'swmodalasesores',
  components: {
    SwInputs,
    SwSaveform,
    SwSearchs,
    ValidationObserver
  },
  props: {
    nameInactive: {
      type: String,
      default: ''
    },
    list_mes: {
      default: null
    },
    list_ano: {
      default: null
    }
  },
  computed: {    
    ...mapState({
    })
  },
  data() {
    return {
      getBackend: [],
      notas_pendientes: {
        id: null,
        id_list_mes: null,
        id_list_ano:null,
        id_datos_afiliado:null,
        id_info_afiliacion:null,
        nota:null,
      },
      precio:0,
      servicios:null,
      name: null
    }
  },
  async created()
  {  
    if(this.dataIndex[this.namePath]!==false && this.dataIndex[this.namePath]!==10000)
    {
      await this.updateDataForm({ state: 'notas_pendientes',data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].notas_pendientes})
      this.notas_pendientes=this.dataForm[this.namePath].notas_pendientes
      this.name=this.gettersDatalist('list_documento',this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].datos_afiliado.id_list_documento)[0].name+' '+this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].datos_afiliado.documento+' '+this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].datos_afiliado.name

      if(this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_afiliacion)
      {      
        await this.updateDataForm({ state: 'datos_afiliado', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].datos_afiliado})        
        this.servicios=this.nameServicios(this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].servicios_activos)
        this.precio=this.preciosServicios([this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].servicios_activos,this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_afiliacion.id_list_novedad])
      }

    }    
    else 
    {      
      this.searchSw.value=''
      this.notas_pendientes.id_list_mes=this.list_mes.id
      this.notas_pendientes.id_list_ano=this.list_ano.id
    }
    await this.updateGlobal({state:'openModal/modal/loaded',data:true})
  },
  destroyed(){
    this.resetDataForm()
  },
  methods: {
    async save(emit)
    {
      try{
        this.notas_pendientes.nota=this.dataForm[this.namePath].notas_pendientes.nota
        await this.updateDataForm({state: 'notas_pendientes',data: this.notas_pendientes})
		    this.$emit('save',{ save: emit.save, ftn: 'pendientesFtn'})
      }catch(e)
      {
        console.log(e)
      }
    },
    async searchsData()
		{
      await this.updateDataForm({state: 'datos_afiliado/id', data: null })
      let data = await this.getData({route: 'get_afiliadopendiente', data: this.searchSw.value})
      this.updateDataForm({state: 'datos_afiliado/id', data: data.datos_afiliado.id })
      this.updateDataForm({state: 'datos_afiliado/direccion', data: data.datos_afiliado.direccion })
      this.updateDataForm({state: 'datos_afiliado/ciudad', data: data.datos_afiliado.ciudad })
      this.updateDataForm({state: 'datos_afiliado/telefonos', data: data.datos_afiliado.telefonos })
      this.updateDataForm({state: 'datos_afiliado/email', data: data.datos_afiliado.email })
      this.servicios=this.nameServicios(data.servicios_activos)
      this.precio=this.preciosServicios([data.servicios_activos,data.info_afiliacion.id_list_novedad])
      this.notas_pendientes.id_datos_afiliado=data.datos_afiliado.id 	
      this.notas_pendientes.id_info_afiliacion=data.info_afiliacion.id 	
      this.notas_pendientes.id_datos_razon=data.info_afiliacion.id_datos_razon	
    },    
    nameServicios(value){ 
      let name=''
      for(let i=0;i<value.length;i++)
      { 
        if(value[i].name!='Administración')
        {
          name=name+' '+value[i].name
          if(value[i].name_list!==null && value[i].name_list!=='')
          {
            name=name+' '+this.gettersDatalist(value[i].name_list,value[i].id_list)[0].name+' '
          }
        }
      } 
      return name
    },
    preciosServicios(value)
    {
     let valor=0	
      for (let i = 0; i < value[0].length; i++) {
        switch(value[1])
        {
          case 1: 
            valor= valor+value[0][i].valoringreso
          break
          case 2: 
            valor= valor+value[0][i].valor
          break
          case 3: 
            valor= valor+value[0][i].valorretiro
          break
          case 4: 
            valor= valor+value[0][i].valor
          break
        }
      }
      
      return valor
    }
  }
}
</script>
<style>
</style>